<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Features',

    metaInfo: { title: 'Features' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        // 'platform-support',
        // 'customer-reviews',
        // 'we-help-your-success',
        // 'info-graph',
        // 'theme-features',
        // 'affiliates',
        'features-in-detail',
        // 'newsletter',
        'info-alt',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
